/** 
 * @module ref/custom 自定义模块
 */
import { ramdomID, complement } from "@/ref/autocdm/utils.js";
import { getParent } from "@/ref/autocdm/threejsUtils.js";
import store from '@/store';

/**
 *排序任务，比方用于模拟建造时，建造的顺序逻辑
 *
 * @param {array} tasks 甘特图任务数据
 * @param {string} sortField 要用来排序的字段，缺省是start_date
 * @param {function} inject 可插入的回调function
 */
export function sortTasks(tasks, sortField, inject) {
    sortField = sortField ? sortField : "start_date";
    tasks.sort(function (a, b) {
        if (inject) {
            inject(a, b);
        }
        let aa = a[sortField], bb = b[sortField];//按开始时间还做顺序
        let r = aa - bb;
        if (r == 0) {
            let cc = a.$wbs ? a.$wbs : a.wbs;
            let dd = b.$wbs ? b.$wbs : b.wbs;
            cc = complement(cc); dd = complement(dd);
            r = cc - dd;
        }
        return r;
    });
};
//----------------------------------------------------------------------------------------------------------

/**
 *
 *根据构件和构件属性，生成任务树。用于【bindDlg】和【自动生成任务数据】
 * @export
 * @param {array} Comps 构件数据
 * @param {object} compInfos 构件属性数据，相关于map数据结构
 * @return {array}  [id:"",label:"",children:[]]
 */
export function buildTasksTree(Comps, compInfos) {
    let projecttype = store.state.tbim.selectedProjectInfo.projecttype;
    let ret = [];
    if (Comps instanceof Array && Comps.length > 0) {
        if (projecttype == "house") {
            let root = { label: "构件树", id: "0", children: [] }; ret.push(root);
            handle(root, Comps, compInfos, function (comp, compInfos) {//第一层树结点：楼层
                let info = compInfos[comp.key];
                let pid = info.floorNumber + "层";
                return pid;
            });
            let children = root.children;
            if (children instanceof Array && children.length > 0) {
                children.forEach(function (p) {
                    let comps = p.children; p.children = [];
                    handle(p, comps, compInfos, function (comp, compInfos) {//第二层树结点：构件类型
                        let info = compInfos[comp.id];
                        let pid = info.componentInfo.componentTypeInfo.typename;
                        return pid;
                    });
                    sortCompType(p.children);
                });
            }
        } else if (projecttype == "Eroad" || projecttype == "Etunnel" || projecttype == "Ebridge" || projecttype == "imported") {
            let root = { label: "构件树", id: "0", children: [] }; ret.push(root);
            let children = root.children;
            Comps.forEach(function (comp) {
                let mid = comp.mid; mid = mid ? mid : ramdomID();
                children.push({ pid: root.id, id: mid, label: comp.label, realid: ramdomID() });
            });
        }
    }
    return ret;
};
/**
 *自动生成任务时，排序构件类型。
 *
 * @param {array} comps
 */
function sortCompType(comps) {
    if (comps && comps instanceof Array) {
        comps.sort(function (a, b) {
            a = a.label;
            let aa = a.indexOf("柱"), bb = a.indexOf("梁"), cc = a.indexOf("板"), dd = a.indexOf("墙");
            aa = aa > -1 ? 4 : 0;
            bb = bb > -1 ? 3 : 0;
            cc = cc > -1 ? 2 : 0;
            dd = dd > -1 ? 1 : 0;
            let aaa = aa + bb + cc + dd;

            b = b.label;
            let aa1 = b.indexOf("柱"), bb1 = b.indexOf("梁"), cc1 = b.indexOf("板"), dd1 = b.indexOf("墙");
            aa1 = aa1 > -1 ? 4 : 0;
            bb1 = bb1 > -1 ? 3 : 0;
            cc1 = cc1 > -1 ? 2 : 0;
            dd1 = dd1 > -1 ? 1 : 0;
            let bbb = aa1 + bb1 + cc1 + dd1;
            return bbb - aaa;
        });
    }
};
/*
 * 根据comps数据生成树
 * @param {*} parent  树将要挂载的父结点
 * @param {*} comps  数据数组
 * @param {*} compInfos 数据属性
 * @param {*} groupIdFun 根据哪些属性做分类。比如楼层，构件类型
 */
function handle(parent, comps, compInfos, groupIdFun) {
    let pset = {};
    let len = comps.length;
    for (let i = 0; i < len; i++) {
        let c = comps[i];
        let pid = groupIdFun(c, compInfos);

        let group = pset[pid];
        if (!group) {
            group = {}; group.id = parent.id + "-" + pid; group.realid = ramdomID(); group.label = pid; group.pid = parent.id; group.children = [];
            pset[pid] = group;
            parent.children.push(group);
        }

        let cc = {}; group.children.push(cc);
        let id = c.key ? c.key : c.id;
        cc.id = id; cc.label = c.label; cc.pid = group.id;
        cc.realid = ramdomID();
    }
};
/**
 * 
 */
//----------------------------------------------------------------------------------------------------------


/**
 *
 * 取当前mesh的名称Label，从属性数据上取。用于初始化mesh时，给mesh加上label，加上的label值就坐这里取
 * @param {THREE.Mesh} mesh threejs的mesh
 * @param {object} compInfos  所有构件的属性数据对应表
 * @return {string} 给mesh显示的名称
 */
export function customModelLabel(mesh, compInfos) {
    let compInfo = compInfos[mesh.key];
    let showlabel = "componentName";
    if (compInfo) {
        let componentname = compInfo.componentname;
        componentname = componentname ? componentname : (compInfo.componentInfo ? compInfo.componentInfo.componentname : showlabel);//TODO
        showlabel = componentname;
    }
    return showlabel;
};

//-----------------------------------------------------------------------------------

/**
 *
 *定制甘特图的row样式
 * @export
 * @param {date} start_date
 * @param {date} end_date
 * @param {object} item
 * @param {object} vue
 * @return {string}  返回class名称
 */
export function grid_row_class(start_date, end_date, item, vue) {
    let currDate = vue.$store.state.tbim.currentDatee;
    if (!item.actual_start_date) {//未开始，无实际开始时间
        if (end_date < currDate) return "notstartred2";
        if (start_date < currDate) return "notstartred1";
        return "notstartred";
    } else if (!item.actual_end_date) {
        if (item.end_date < item.actual_start_date) return "doing2";
        if (item.start_date < item.actual_start_date) return "doing1";
        return "doing";
    } else {
        if (item.end_date < item.actual_end_date) return "finished2";
        return "finished";
    }
};


/**
 *
 * 取到，生成所有构件的属性数据对应表compInfos，区分类型，house,Eroad,Etunnel,Ebridge。
 * @export
 * @param {object} data  当是house类型时，data是属性数据。当是road等类型时，data是three的group
 * @param {string} projectType 项目/工程类型 house,road,tunnel,bridge
 * @return {object} 返回compInfos每个构件对应的属性数据，{compid:props}
 */
export function customCompInfos(data, projectType) {
    let compInfos = {};
    if (projectType == "house") {
        for (let i = 0; i < data.length; i++) {
            let d = data[i];
            compInfos[d.id] = d;
        }
    } else if (projectType == "Ebridge" || projectType == "Etunnel" || projectType == "Eroad") {
        data.traverse(function (mesh) {
            if (mesh.type == 'Mesh') {
                mesh = getParent(mesh);//如果parent有mid，则取parent，否则取自己
                let k = mesh.mid;
                if (!compInfos[k]) {
                    let name = mesh.componentName;
                    name = name ? name : mesh.mstype;
                    name = name ? name : mesh.mid;
                    compInfos[k] = { id: mesh.mid, floorNumber: 0, componentname: name };
                }
            }
        });
    } else if (projectType == "imported") {
        data = data.componentList;
        for (let i = 0; i < data.length; i++) {
            let d = data[i]; d.name = d.name ? d.name : "name"; d.componentname = d.name;
            compInfos[d.id] = d;
        }
    }
    return compInfos;
};



// WEBPACK FOOTER //
// ./src/ref/custom.js